module.exports = __webpack_public_path__ + "media/bell.b2a5951b.wav";